<template>
  <div :class="this.$route.name === 'home' ? '' : 'flex flex-col h-full'">
    <a href="#main-content" class="content-link focus:outline-none bg-au_primary text-white fixed right-0 left-0 z-10 py-2 viewport-gutter">
      <div class="container underline">
        {{ tr('common.skipToMainContent') }}
      </div>
    </a>
    <branded-header :href="$router.currentRoute.meta.headerHref" />
    <a
      id="focusResetAnchor"
      tabindex="-1"
      class="hidden"
      href="https://flightvoucher.com"
    >Focus reset</a>

    <router-view />

    <branded-footer v-if="!$router.currentRoute.meta.hideFooter" />
  </div>
</template>

<script>
import BrandedHeader from '~brand-components/austrian/shared/header.vue'
import BrandedFooter from '~brand-components/austrian/shared/footer.vue'

export default {
  components: {
    BrandedHeader,
    BrandedFooter,
  },
}
</script>

<style lang="scss" scoped>
.content-link {
  &:focus {
    top: 60px;
    @media screen and (min-width: 768px) {
      top: 90px;
    }
  }
}
</style>
